'use strict';

const cart = require('../cart/cart');
const approachingDiscounts = require('./approachingDiscounts');

let updateMiniCart = true;
let approachingDiscountObj = {
    callouts: [],
    unlocked: []
};

const location = window.location;
// Check if user is on cart page - if yes, reload page instead of opening modal
var pathname = window.location.pathname.toLowerCase();
var isCartPage = $('.cart-page').length > 0
    || $('body').hasClass('cart-page')
    || pathname.indexOf('cart-show') !== -1
    || pathname === '/cart'
    || pathname.indexOf('/cart/') !== -1
    || $('.page').data('action') === 'Cart-Show';

module.exports = function () {
    cart();

    /**
     * Helper function to open minicart modal
     */
    function openMiniCartModal() {
        const url = $('.minicart').data('action-url');
        const $modal = $('#minicartModal');

        if (!updateMiniCart && $modal.find('.cart').length > 0) {
            $('.minicart-modal-total-quantity').text(parseInt($('#minicart-total-quantity').val(), 10) || $('.minicart-quantity').text());
            // Check if cart is empty and hide/show header accordingly
            if ($modal.find('[data-cart-empty]').length > 0 && !$modal.find('[data-cart-empty]').hasClass('d-none')) {
                $modal.find('.minicart-modal-header').removeClass('d-flex').addClass('d-none');
            } else {
                $modal.find('.minicart-modal-total-quantity').addClass('d-flex');
                $modal.find('.minicart-modal-header').removeClass('d-none').addClass('d-flex');
            }
            approachingDiscountObj = approachingDiscounts.init($modal);
            $modal.addClass('show');
            $('body').addClass('minicart-modal-open');
            return;
        }

        // Check if cart has items before loading content
        const hasItems = parseInt($('#minicart-total-quantity').val(), 10) > 0 || parseInt($('.minicart-quantity').text(), 10) > 0;
        if (!hasItems) {
            $modal.find('.minicart-modal-header').removeClass('d-flex').addClass('d-none');
        } else {
            $modal.find('.minicart-modal-total-quantity').addClass('d-flex');
            $modal.find('.minicart-modal-header').removeClass('d-none').addClass('d-flex');
        }

        if (isCartPage) {
            // User is on cart page, reload to refresh cart
            window.location.reload();
            return;
        }
        $modal.addClass('show');
        $('body').addClass('minicart-modal-open');
        // Clear stale content (e.g. a previously rendered express/PayPal button) before
        // showing the loader, so the old button doesn't flash before the fresh content loads.
        $modal.find('.minicart-modal-body').empty();
        $modal.find('.minicart-modal-body').spinner().start();

        $.get(url, function (data) {
            $modal.find('.minicart-modal-body').html(data);
            $('.minicart-modal-total-quantity').text(parseInt($('#minicart-total-quantity').val(), 10) || $('.minicart-quantity').text());

            // Check if cart is empty after content is loaded and hide/show header accordingly
            if ($modal.find('[data-cart-empty]').length > 0 && !$modal.find('[data-cart-empty]').hasClass('d-none')) {
                $modal.find('.minicart-modal-header').removeClass('d-flex').addClass('d-none');
            } else {
                $modal.find('.minicart-modal-total-quantity').addClass('d-flex');
                $modal.find('.minicart-modal-header').removeClass('d-none').addClass('d-flex');
            }

            // Seed approaching-discount tracking for this open.
            approachingDiscountObj = approachingDiscounts.init($modal);

            updateMiniCart = false;
            $.spinner().stop();
        });
    }

    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal);
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }
    });

    // Open minicart modal on click
    $('.minicart-link').on('click', function (e) {
        if (isCartPage) {
            // User is on cart page, reload to refresh cart
            e.preventDefault();
            window.location.reload();
            return;
        }

        e.preventDefault();
        openMiniCartModal();
    });

    // Remove product from minicart
    $('body').on('click', '#minicartModal .remove-product', function (e) {
        e.preventDefault();

        var $btn = $(this);
        var uuid = $btn.data('uuid');
        var url = $btn.data('action') + '?pid=' + $btn.data('pid') + '&uuid=' + uuid;
        var $modal = $('#minicartModal');
        // Find product-line-item - try closest first, then find via UUID card
        var $productCard = $btn.closest('.product-line-item');
        if (!$productCard.length) {
            $productCard = $('.uuid-' + uuid).find('.product-line-item');
        }
        var $loadingOverlay = $productCard.find('.minicart-image-loading-overlay');

        // Show loading animation on product image instead of global spinner
        if ($loadingOverlay.length) {
            $loadingOverlay.removeClass('d-none').css('display', 'flex');
        }

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                // Always remove the product card first (overlay will be removed with it)
                $('.uuid-' + uuid).closest('.minicart-product-row').remove();

                if (data.basket.items.length === 0) {
                    // Hide cart content, show empty state
                    $modal.find('[data-cart-content]').addClass('d-none');
                    $modal.find('[data-cart-empty]').removeClass('d-none');
                    $modal.find('.minicart-modal-header').removeClass('d-flex').addClass('d-none');
                    $modal.find('.cart-not-empty').removeClass('d-flex').addClass('d-none');
                    // Hide quantity badge when cart is empty
                    $modal.find('.minicart-modal-total-quantity').text('').hide();
                } else {
                    // Update totals if there are still items
                    $modal.find('.sub-total').text(data.basket.totals.subTotal);
                    // Update quantity badge in header
                    $modal.find('.minicart-modal-total-quantity').text(data.basket.numItems).show();
                }

                // Update hidden input and quantity display
                $('#minicart-total-quantity').val(data.basket.numItems);
                $('.minicart-quantity').text(data.basket.numItems);
                $('.minicart-link').attr({
                    'aria-label': data.basket.resources.minicartCountOfItems,
                    title: data.basket.resources.minicartCountOfItems
                });

                updateMiniCart = true;
                $('body').trigger('cart:update', data);
            },
            error: function (err) {
                // Hide loading animation on error
                if (err.responseJSON && err.responseJSON.errorMessage) {
                    $modal.find('.minicart-modal-error').removeClass('d-none').find('.invalid-mini-cart-error-message').text(err.responseJSON.errorMessage);
                }
                $loadingOverlay.addClass('d-none');
            }
        });
    });

    // Close modal when clicking close button
    $('body').on('click', '.minicart-modal-close', function () {
        var $modal = $('#minicartModal');

        // Add closing class and remove show class
        $modal.removeClass('show').addClass('closing');
        $('body').removeClass('minicart-modal-open');

        // Hide modal after animation completes
        setTimeout(function () {
            $modal.removeClass('closing');
        }, 300);
    });

    // Close modal when clicking overlay
    $('body').on('click', '.minicart-modal-overlay', function () {
        var $modal = $('#minicartModal');

        // Add closing class and remove show class
        $modal.removeClass('show').addClass('closing');
        $('body').removeClass('minicart-modal-open');

        // Hide modal after animation completes
        setTimeout(function () {
            $modal.removeClass('closing');
        }, 300);
    });

    // Prevent modal content clicks from closing modal
    $('body').on('click', '.minicart-modal-content', function (e) {
        e.stopPropagation();
    });

    $('body').on('change', '.minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });

    // Prevent entering 0 while typing and handle Enter key
    $('body').on('keypress', '#minicartModal .quantity-form > .quantity[type="text"]', function (e) {
        var $input = $(this);
        var currentValue = $input.val();
        var key = String.fromCharCode(e.which);
        var min = parseInt($input.attr('min'), 10) || 1;

        // Handle Enter key - trigger blur for validation
        if (e.which === 13) {
            e.preventDefault();
            $input.blur(); // Trigger blur which will validate and trigger change
            return false;
        }

        // Prevent typing 0 if it would result in just "0" or "0" at the start
        if (key === '0' && (currentValue === '' || currentValue === '0')) {
            e.preventDefault();
            $input.val(min);
            return false;
        }

        return true;
    });

    // Prevent entering 0 or negative values while typing (for paste/other input methods)
    $('body').on('input', '#minicartModal .quantity-form > .quantity[type="text"]', function () {
        var $input = $(this);
        var value = $input.val();
        var min = parseInt($input.attr('min'), 10) || 1;

        // If user pastes or types 0, convert it to minimum
        if (value === '0' || (value.length > 0 && parseInt(value, 10) === 0)) {
            $input.val(min);
        }
    });

    // Handle text input quantity selector - validate and trigger change on blur
    $('body').on('blur', '#minicartModal .quantity-form > .quantity[type="text"]', function () {
        var $input = $(this);
        var min = parseInt($input.attr('min'), 10) || 1;
        var max = parseInt($input.attr('max'), 10) || 999;
        var preSelectQty = parseInt($input.data('pre-select-qty'), 10) || min;
        var value = parseInt($input.val(), 10);
        var totalQuantity = parseInt($('.minicart-modal-total-quantity').text(), 10) + value - preSelectQty;

        // Validate and correct value
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(value) || value < min) {
            value = min;
        } else if (value > max) {
            value = max;
        }

        // Only trigger change if value actually changed
        if (value !== parseInt($input.val(), 10) || value !== preSelectQty) {
            // Ensure value is always an integer (no decimal)
            $input.val(Math.floor(value));
            $('.minicart-modal-total-quantity').text(totalQuantity);

            // Show loading animation on product image before triggering change
            var $productCard = $input.closest('.product-line-item');
            var $loadingOverlay = $productCard.find('.minicart-image-loading-overlay');
            if ($loadingOverlay.length) {
                $loadingOverlay.removeClass('d-none').css('display', 'flex');
            }

            // Listen for cart update to hide loading animation
            $('body').one('cart:update', function () {
                if ($loadingOverlay.length) {
                    $loadingOverlay.addClass('d-none');
                }
                // Stop any spinner that might have been triggered by cart.js
                $productCard.closest('.card').spinner().stop();
                $('#minicartModal').find('.card').spinner().stop();
            });

            // Prevent spinner from showing in minicart - stop it immediately if cart.js triggers it
            $input.trigger('change');

            // Stop spinner immediately after change event (cart.js will start it)
            setTimeout(function () {
                $productCard.closest('.card').spinner().stop();
                $('#minicartModal').find('.card').spinner().stop();
            }, 0);
        }
    });

    $('body').on('product:afterAddToCart', function (e, data) {
        updateMiniCart = true;
        // Open minicart modal when product is successfully added to cart
        if (data && !data.error) {
            // Check if bonus product modal is open or will open
            // If bonus products are available, don't open minicart yet
            // Minicart will open after bonus modal closes
            if (data.newBonusDiscountLineItem && Object.keys(data.newBonusDiscountLineItem).length !== 0) {
                // Store flag to open minicart after bonus modal closes
                $(document).data('openMinicartAfterBonus', true);
                return; // Don't open minicart now
            }
            // No bonus products, open minicart as usual
            openMiniCartModal();
        }
    });

    // Open minicart after bonus modal closes (whether user adds products or cancels)
    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        // Remove bonus modal class when modal closes
        $('body').removeClass('bonus-modal-open');

        if ($(document).data('openMinicartAfterBonus')) {
            $(document).removeData('openMinicartAfterBonus');
            // Small delay to ensure bonus modal is fully closed and animations complete
            setTimeout(function () {
                // Check if minicart modal is not already open
                if (!$('#minicartModal').hasClass('show')) {
                    openMiniCartModal();
                }
            }, 300);
        }
    });

    /**
     * Refreshes just the mini cart product rows from the server.
     * @param {Object} $modal - jQuery object of the minicart modal
     */
    function refreshMinicartProductRows($modal) {
        var url = $('.minicart').data('action-url');
        if (!url) {
            return;
        }

        $.get(url, function (html) {
            var $rows = $('<div>').append(html).find('.product-summary');
            if ($rows.length) {
                $modal.find('.product-summary').html($rows.html());
            }
        });
    }

    $('body').on('cart:update', function (e, data) {
        updateMiniCart = true;

        var $modal = $('#minicartModal');
        // Treat a quantity decrease like a removal: the shopper moved away from the threshold, so
        // promos that fell out of the approaching range must not show the "unlocked" confirmation.
        var isRemoval = Boolean(data && (data.basket || data.qtyDecreased));
        var basket = data && data.basket ? data.basket : data;

        if (basket.items && basket.items.length !== $modal.find('.minicart-product-row').length) {
            refreshMinicartProductRows($modal);
        }

        approachingDiscounts.render($modal, approachingDiscountObj, basket.approachingDiscounts, isRemoval);
    });
};
